export default __webpack_public_path__ + "static/media/jfet.c488bf7a.svg";